<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section', block.bgcolour]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <div class="columns is-multiline">
            <div class="column is-12">
                <div ref="content" class="content" v-html="block.content"></div>
            </div>
            <div :class="['column 1s-12 cta has-text-centered']" v-if="block.cta && block.cta.button">
                <CTALink :link_data="block.cta" />
            </div>
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
export default {
    name        :   'PlainContentBlock',
    mixins      :   [ BlockCommons ],
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
}
</script>
<style lang="scss" scoped>
.cta {
    padding-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/modules/PlainContentBlock.vue